export default __webpack_public_path__ + "static/media/oliver.623c0276.png";